export enum PatternEnum {
    '2-way' = '2-way',
    '3-way' = '3-way',
    '6-way' = '6-way',
}
